/**
 * Adresteki `#bölüm` ile sayfa içi bölüme iner (örn. `/ayarlar#vade`).
 * Üstteki listeler sonradan yüklenip bölümü aşağı ittiği için kısa aralıklarla
 * birkaç kez yinelenir. Dönen işlev zamanlayıcıları temizler.
 */
export function hashaKaydir(id: string): () => void {
  if (window.location.hash !== `#${id}`) return () => undefined;
  const git = () => document.getElementById(id)?.scrollIntoView({ block: 'start' });
  git();
  const z = [250, 700, 1500].map((ms) => window.setTimeout(git, ms));
  return () => z.forEach((t) => window.clearTimeout(t));
}
